import { Flex, Input, Text } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { useModalState } from '~/atoms/ModalState'
import { useSettingsState } from '~/atoms/SettingsState'
import { useUserState } from '~/atoms/UserState'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { MangoButton } from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import { formatPhoneNumber } from '~/utils/formatter'

import { useNewSpeedDialModalStyle } from './componentStyles/NewSpeedDialModal.style'

export const NewSpeedDialModal = () => {
  const labelRef = useRef<HTMLInputElement>(null)
  const numberRef = useRef<HTMLInputElement>(null)

  const [labelText, setLabelText] = useState<string>('')
  const [numberText, setNumberText] = useState<string>('')
  const {
    speedDialModal: [speedDialModalState, setSpeedDialModalState],
  } = useModalState()
  const { pbxId } = useUserState()
  const { updateSpeedDial } = useSettingsState(pbxId)

  const handleLabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLabelText(e.target.value)
  }

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNumberText(formatPhoneNumber(e.target.value))
  }

  useEffect(() => {
    setLabelText(speedDialModalState.speedDial?.label || '')
    setNumberText(speedDialModalState.speedDial?.number || '')
  }, [speedDialModalState])

  const handleClose = () => {
    setSpeedDialModalState({ open: false })
    setLabelText('')
    setNumberText('')
  }
  const handleSave = () => {
    if (labelText && numberText) {
      updateSpeedDial(labelText, numberText, speedDialModalState.speedDial?.id)
      handleClose()
    }
    if (!labelText) {
      labelRef.current?.focus()
    }
    if (!numberText) {
      numberRef.current?.focus()
    }
  }

  const styles = useNewSpeedDialModalStyle()

  return (
    <MangoModal
      isOpen={speedDialModalState.open}
      onClose={handleClose}
      header={
        speedDialModalState.speedDial?.id ? 'Edit Speed Dial' : 'Add Speed Dial'
      }
      body={
        <Flex sx={styles.bodyContainer}>
          <Flex sx={styles.inputContainer}>
            <Text sx={styles.inputLabel}>Contact Name</Text>
            <Input
              ref={labelRef}
              variant="mango"
              placeholder={'Contact Name'}
              value={labelText}
              onChange={handleLabelChange}
            />
          </Flex>
          <Flex sx={styles.inputContainer}>
            <Text sx={styles.inputLabel}>Number</Text>
            <Input
              ref={numberRef}
              variant="mango"
              placeholder={'Number'}
              value={formatPhoneNumber(numberText)}
              onChange={handleNumberChange}
            />
          </Flex>
        </Flex>
      }
      footer={
        <Flex sx={styles.footerContainer}>
          <MangoButton
            variant={MangoButtonVariant.Default_100}
            onClick={handleClose}
          >
            Cancel
          </MangoButton>
          <MangoButton
            variant={MangoButtonVariant.Default_300}
            onClick={handleSave}
          >
            Save
          </MangoButton>
        </Flex>
      }
    ></MangoModal>
  )
}
